const _require = require('@truqc/content-path'),
  appendPath = _require.appendPath;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate appendPathBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  const requireAllValues = await evaluateSource(source.requireAllValues, content, parentContentPath, transientContext, nativeFunctions);
  if (requireAllValues === true && values.some(item => item === undefined)) {
    return undefined;
  }
  return values.reduce((acc, value) => acc === undefined ? value : appendPath(acc, value), undefined);
};
module.exports = {
  evaluate
};